import type { LucideIcon } from 'lucide-react';
import {
  BarChart3,
  Crosshair,
  FileText,
  Settings,
  Eye,
  Radar,
  Telescope,
  ShieldCheck,
  TrendingUp,
} from 'lucide-react';

export type TraderView =
  | 'dashboard'
  | 'positions'
  | 'trades'
  | 'settings'
  | 'streamrift'
  | 'g3'
  | 'g4';

export type ManagerView = 'manager-traders' | TraderView;

export type AdminView = 'admin-manage' | 'admin-traders' | TraderView;

export type AppView = TraderView;

export interface NavItem<V extends string = string> {
  id: V;
  icon: LucideIcon;
  label: string;
  section?: 'manage' | 'trade';
}

export const TRADER_NAV_ITEMS: NavItem<TraderView>[] = [
  { id: 'dashboard', icon: BarChart3, label: 'Value Dashboard', section: 'trade' },
  { id: 'positions', icon: Crosshair, label: 'Position Tracker', section: 'trade' },
  { id: 'trades', icon: FileText, label: 'My Trades', section: 'trade' },
  { id: 'settings', icon: Settings, label: 'Settings', section: 'trade' },
  { id: 'streamrift', icon: Eye, label: 'StreamRift', section: 'trade' },
  { id: 'g3', icon: Radar, label: 'G3', section: 'trade' },
  { id: 'g4', icon: Telescope, label: 'G4', section: 'trade' },
];

// Items rendered in the footer (below the user name), in the listed order.
export const FOOTER_NAV_ORDER: readonly string[] = ['settings', 'manager-traders', 'admin-traders'];
export const FOOTER_NAV_IDS: ReadonlySet<string> = new Set(FOOTER_NAV_ORDER);

export const MANAGER_NAV_ITEMS: NavItem<ManagerView>[] = [
  { id: 'manager-traders', icon: TrendingUp, label: 'Org Settings', section: 'manage' },
  ...TRADER_NAV_ITEMS,
];

export const ADMIN_NAV_ITEMS: NavItem<AdminView>[] = [
  { id: 'admin-manage', icon: ShieldCheck, label: 'Management', section: 'manage' },
  { id: 'admin-traders', icon: TrendingUp, label: 'Org Settings', section: 'manage' },
  ...TRADER_NAV_ITEMS,
];

export const NAV_ITEMS = TRADER_NAV_ITEMS;
